import { mobileFormTypes } from '../../mobileForm/hooks/useExtendedFormActions';
import useMobileForm from '../../mobileForm/hooks/useMobileForm';

const useFinalCustomerExtendedForm = ({ idApp, values }) => {
  const reviewFormData = useMobileForm({ idApp, values, itemType: mobileFormTypes.finalCustomer });

  return reviewFormData;
};

export default useFinalCustomerExtendedForm;
